import { useEffect, useState } from "react";
import logo from "../../../assets/pyne_images/Logo_2.png";
import axios from "axios";
import style from "./settings.module.css";

const SettingsDataT = ({ type }) => {
  const BASELINK = `https://www.pyne-mena.com/api/`;
  const [data, setData] = useState([]);

  const getData = (typeUrl) => {
    axios
      .get(BASELINK + `settings/get_terms_privacy?type=${typeUrl}`)
      .then((res) => {
   
          setData(res.data.data.terms_and_conditions_en);
        
      });
  };
  useEffect(() => {

      getData("terms");
    
  }, []);
  const theObj = { __html: data };
  return (
    <div>
      <div style={{display:'flex',justifyContent:'center',marginTop:40,marginBottom:40}}>
        <img
          onClick={() => {
            window.open('https://pyne-mena.com')
          }}
          src={logo}
          className={style.logo}
        />
      </div>
      <hr />
      <div
        dangerouslySetInnerHTML={theObj}
        style={{ color: "black", margin: 10 }}
      />
    </div>
  );
};
export default SettingsDataT;
